// extracted by mini-css-extract-plugin
export default {"modalErrorIcon":"modalErrorIcon-_gzMKC"};